export default {
  path: '/v5/coach',
  name: 'V5_coach',
  component: () => import('./CoachPage.vue'),
};
